import React, {createRef, useState, useContext} from 'react';
import {useQueryClient} from "react-query";
import moment from 'moment';
import SystemContext from "../../../SystemContext";
import { Grid, Button } from "@material-ui/core";
import {Flight as FlightIcon, Edit} from "@material-ui/icons";
import BookingForm from '../../Booking/components/BookingForm';
import useCurrencies from "../../../services/currencies/useCurrencies";
import useExchangeRates from "../../../services/currencies/useExchangeRatesWithName";
import {useSettings} from "../../../services/settings";

const ShipmentTrackingAirwaybill = (_props) => {
  const props = {
    canEdit: false,
    ..._props,
  }

  const classes = props.classes;
  const [record, setRecord] = useState(props.record);
  const [editBooking, setEditBooking] = useState ({
    open: false,
    bookingRecord: null,
  });

  if ((props.record && !record) || (!props.record && record) || (props.record && record && props.record.awbNo !== record.awbNo) ) {
    setRecord(props.record);
    if (editBooking.open) {
      setEditBooking({open: false, bookingRecord: null});
    }
  }
  console.log(`ROUTE`, JSON.stringify(_props.route));

  const SystemData = useContext(SystemContext);
  const queryClient = useQueryClient();
  const rateExtraKeys = ["SYSTEM", moment().format("YYYY-MM-DD")];
  const currencies = useCurrencies(queryClient, []);
  const exchangeRates = useExchangeRates({queryClient, extraKeys: rateExtraKeys});
  const terms = useSettings({queryClient, extraKeys: ["TERMS"]});
  const spotBookings = false;

  const handleViewBooking = () => {
    //debugger;
    setEditBooking({
      open: true,
      bookingRecord: record
    });
  }

  return (
    <div key="awbContainer" style={{height: 70, textAlign:"left", backgroundColor: "#ffffff", padding: 10, color: "#404040"}}>
      {record ?
      <Grid
        container
        spacing={1}
        direction="row"
        justify="flex-start"
        alignItems="flex-start"
      >
        <Grid item xs={2} key='awb'>
          <div style={{display:"block", height: 30, fontSize: 14}}>Air Waybill</div>
          <div style={{display:"block", height: 40, fontSize: 24}}>{record.awbNo}</div>
        </Grid>
        <Grid item xs={2} key='piecesWeight'>
          <div style={{display:"block", height: 30, fontSize: 14}}>Expected Pieces/Weight</div>
          <div style={{display:"block", height: 40, fontSize: 24}}>{record.expectedPieces} / {record.expectedWeight}kg</div>
        </Grid>
        <Grid item xs={2} key='commodity'>
          <div style={{display:"block", height: 30, fontSize: 14}}>Description of Goods</div>
          <div style={{display:"block", height: 40, fontSize: 24}}>{record.commodity}</div>
        </Grid>
        <Grid item xs={2} key='status'>
          <div style={{display:"block", height: 30, fontSize: 14}}>Status</div>
          <div style={{display:"block", height: 40, fontSize: 24}}>{record.bookingStatus}</div>
        </Grid>
        <Grid item xs={3} key='route'>
          <div style={{display:"block", height: 30, fontSize: 14}}>Route</div>
          <div style={{display:"block", height: 40, fontSize: 24}}>
            {_props.route?_props.route.map((airport, i)=>(
              <><span style={{}}>{airport.airportCode}</span>{(i !== _props.route.length -1 ) ? <div style={{display:"inline-block", position:"relative", top: 3, padding: "0px 4px"}}><FlightIcon style={{color: "#ff8d3e", transform: "rotate(90deg)"}}/></div>:<></>}</>
            ))
            :''}
          </div>
        </Grid>
        <Grid item xs={1} key='status' style={{textAlign: "right"}}>
          <div style={{display:"block", height: 24, fontSize: 14}}></div>
          <div style={{display:"block", height: 40, fontSize: 24}}><Button variant="contained" color="primary" startIcon={<Edit />}  onClick={handleViewBooking}>Details</Button></div>
        </Grid>
      </Grid>
      :<></>
    }
    {editBooking.open ?
      <BookingForm
        record={editBooking.bookingRecord}
        canEdit={props.canEdit}
        newBooking={false}
        formMode={"GSA"} // GSA - for GSA bookings (does not require GSA selection), OPERATOR - for system operator bookings (requires GSA selection)
        captureParticipants={spotBookings ? false : true}
        close={()=>{setEditBooking({open: false, rowData: null})}}
        classes={classes}
        exchangeRates={exchangeRates.data}
        currencies={currencies}
        terms={terms.data}
        dialogStates={{showDialog: editBooking.open, awb: editBooking.bookingRecord.awbNo, gsaCompanyUuid: editBooking.bookingRecord.gsaCompanyUuid}}
      />
      : <></>
    }
    </div>
  );
}

export default ShipmentTrackingAirwaybill;
